import React from "react";
import classes from "./gallerySection.module.css";
import Title from "../../containers/title/title";
import Gallery from "../../containers/gallery/gallery";

function GallerySection(props) {
  return (
    <section className={classes.Gallery}>
      <Title title={parseInt(localStorage.getItem('language')) === 1 
        ? "Gallery" 
        : "معرض الصور"} 
      />
      <Gallery images={props.gallery} />
    </section>
  );
}

export default GallerySection;
